/* @ngInject */

export default ($q, $http, logger, HOME_LOAN) => {
  /**
   * Get LMI.
   *
   * @param {Object} [params]
   *
   * @returns {Array}
   */
  const downloadCalculator = (params) => {
    const deferred = $q.defer();
    logger.log('homeLoanDataFactory', 'downloadCalculator', 'Resolving data from API');
    $http
      .post(
        HOME_LOAN.API.DOWNLOAD_CALCULATOR,
        { params },
        {
          responseType: 'arraybuffer',
          transformResponse: (data) => {
            let zip;
            if (data) {
              zip = new Blob([data], { type: 'application/octet-stream' });
            }
            return {
              response: zip
            };
          }
        }
      )
      .then(
        (data) => {
          logger.debug('homeLoanDataFactory', 'downloadCalculator', 'Resolved data from API');
          saveAs(
            data.data.response,
            `${(params.ticketName || '').replace(/[^a-zA-Z0-9. ]+/gi, '') || 'Export'}.stsp`
          );
          deferred.resolve(true);
        },
        (err) => {
          logger.error(
            `homeLoanDataFactory | downloadCalculator | Error while resolving data ${err}`
          );
          deferred.reject();
        }
      );
    return deferred.promise;
  };

  /**
   * Get Astute Commission.
   *
   * @param {Object} [params]
   *
   * @returns {Array}
   */
  const astuteCommission = (params) => {
    const deferred = $q.defer();
    logger.log('homeLoanDataFactory', 'astuteCommission', 'Resolving data from API');
    $http.get(HOME_LOAN.API.SEND_COMMISSION, { params }).then(
      (payload) => {
        logger.debug('homeLoanDataFactory', 'astuteCommission', 'Resolved data from API');
        deferred.resolve(payload.data);
      },
      (err) => {
        logger.error(
          `homeLoanDataFactory | astuteCommission | Error while resolving data ${err}`
        );
        deferred.reject();
      }
    );
    return deferred.promise;
  };

  return {
    downloadCalculator,
    astuteCommission
  };
};
